module.exports={Remove:"Видалити"};